<template>
  <a-modal
    :keyboard="false"
    :maskClosable="false"
    v-model="visible"
    :title="title"
    width="1000px"
    @ok="onOk"
    @cancel="close"
  >
    <div class="flex">
      <div class="left-content">
        <CommonTable
          :loading="loading"
          :columns="columns"
          :dataSource="dataSource"
          :selectedRowKeys.sync="selectedRowKeys"
          :selectedRows.sync="selectedRows"
          :total="total"
          :showSelect="true"
          :showPagination="true"
          :showSetting="false"
          :rowKey="rowKey"
          @select="onChange"
          @search="getList"
        ></CommonTable>
      </div>
      <div class="right-content">
        <div class="flex-ct title between">
          <div class="text-disabled">
            <span>{{ $t('已选') }}</span>
            <span class="ml4" v-if="selectedRowKeys.length > 0">
              ({{ selectedRowKeys.length }})
            </span>
          </div>
          <div class="text-link" @click="onClear">{{ $t('清空') }}</div>
        </div>
        <div class="row-content">
          <div class="row-item flex-ct" v-for="(item, index) in selectedRows" :key="index">
            <span>{{ item.name }}</span>
            <a-icon type="close" class="delete-icon" @click="onDelete(index)" />
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import http from '@/service/axios'
import api from '@/service/api'
export default {
  props: {
    title: { type: String, default: '请选择' },
    columns: {
      type: Array,
      default: () => [],
    },
    params: {
      type: Object,
      default: () => ({}),
    },
    api: {
      type: String,
    },
    rowKey: {
      type: String,
      default: 'id',
    },
    selecteds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      dataSource: [],
      total: 0,
      pageNo: 1,
      pageSize: 20,
      selectedRowKeys: [],
      selectedRows: [],
    }
  },
  watch: {
    api(nVal, oVal) {
      if (nVal === oVal) return
      this.dataSource = []
    },
    params(nVal, oVal) {
      if (nVal === oVal) return
      this.dataSource = []
    },
    selecteds(val) {
      if (val?.length > 0) {
        this.selectedRows = val
        this.selectedRowKeys = val.map((item) => item[this.rowKey])
      } else {
        this.onClear()
      }
    },
  },
  methods: {
    open() {
      this.visible = true
      this.getList()
    },
    close() {
      this.visible = false
    },
    onChange(ids, rows) {
      this.selectedRowKeys = ids
      this.selectedRows = rows
    },
    async getList(query) {
      // 打开弹窗且已有数据时不重复请求，翻页时按 query 重新请求
      if (!query && this.dataSource.length > 0) return
      this.pageNo = query?.page_no || this.pageNo
      this.pageSize = query?.page_size || this.pageSize
      this.loading = true
      try {
        let res = await http({
          url: api[this.api],
          data: {
            ...this.params,
            page_no: this.pageNo,
            page_size: this.pageSize,
          },
        })
        const result = res.result || {}
        let list = result.list || (Array.isArray(result) ? result : [])
        if (list.length === 0) {
          this.$message.warning(this.$t('数据为空'))
        }
        this.total = result.total || 0
        this.dataSource = list
      } catch (err) {
        // 请求失败时保留已有数据，避免表格卡在 loading 状态
      } finally {
        this.loading = false
      }
    },
    onOk() {
      this.$emit('ok', this.selectedRows)
      this.close()
    },
    onClear() {
      this.onChange([], [])
    },
    onDelete(index) {
      this.selectedRowKeys.splice(index, 1)
      this.selectedRows.splice(index, 1)
    },
  },
}
</script>

<style lang="scss" scoped>
.left-content {
  flex: 1;
}
.right-content {
  min-width: 300px;
  border: 1px solid #e8e8e8;
  .title {
    padding: 5px 10px;
  }
  .row-content {
    .row-item {
      cursor: pointer;
      padding: 5px 10px;
      .delete-icon {
        visibility: hidden;
        font-size: 16px;
        margin-left: auto;
        color: gray;
      }
      &:hover {
        background-color: #f6f5f8;
        .delete-icon {
          visibility: visible;
        }
      }
    }
  }
}
</style>
